/**
 * FRAGRANCE_QUIZ_PROFILES (B2B)
 * Profile texts for the Heinsson Scent Trinity™ Profiler (v6, B2B version).
 * Consumed by the B2B quiz JS — no module syntax, plain global assignment.
 *
 * German is the source. The English set is selected at runtime via window.FQ_LANG
 * (set by the section Liquid from request.locale). US English follows the
 * Heinsson tonality: no exclamation marks, no dashes, direct "you" address.
 *
 * Structure:
 *   intro         — per-family opening text (16 families, Mensing wheel v6) — B2B framing
 *   bridge        — primary → secondary connector (Trio-System: direct neighbors) — unchanged from B2C
 *   presence      — spatial presence modifier (4 levels) — B2B framing
 */

window.FRAGRANCE_QUIZ_PROFILES_DE = {

  intro: {

    'fruchtig':
      'Dein Markenduft ist purer Genuss: saftig, reif und leuchtend. Er weckt bei deiner ' +
      'Zielgruppe sofort Freude und gibt deiner Marke eine lebensfrohe, unbeschwerte Leichtigkeit.',

    'zitrisch':
      'Dein Markenduft kommt sofort an: spritzig, prickelnd und befreiend hell. Er öffnet den Tag ' +
      'deiner Zielgruppe und positioniert deine Marke optimistisch, wach und aufgeschlossen.',

    'aromatisch':
      'Dein Markenduft riecht nach zerriebenen Kräutern zwischen den Fingern: krautig, botanisch, direkt. ' +
      'Er macht deine Zielgruppe wach und verankert deine Marke fokussiert, vital und tatkräftig.',

    'aquatisch':
      'Dein Markenduft trägt die Weite des Meeres in sich: wässrig, maritim, mineralisch klar. ' +
      'Er macht den Kopf frei und gibt deiner Marke eine befreite, ausgeglichene Klarheit.',

    'frisch':
      'Dein Markenduft ist Reinheit: kühl, kristallin und puristisch. Er begleitet ohne Umschweife ' +
      'und stellt deine Marke erfrischt, leicht und gelöst auf.',

    'floral-klar':
      'Dein Markenduft ist Luft selbst: luftig, transparent und schwebend. Er nimmt jede Schwere ' +
      'und gibt deiner Marke einen heiteren, ungezwungenen und entspannten Auftritt.',

    'gruen':
      'Dein Markenduft ist der erste Atemzug im Garten: grün, blättrig und knackig. ' +
      'Er wirkt erholsam und positioniert deine Marke zuversichtlich, erholt und geerdet.',

    'floral':
      'Dein Markenduft hat die Eleganz von Blüten: blumig, elegant und betörend. ' +
      'Er berührt deine Zielgruppe und gibt deiner Marke eine anmutige, zärtliche und herzliche Note.',

    'pudrig':
      'Dein Markenduft legt sich wie ein weicher Mantel um die Schultern: pudrig, samtig und weich. ' +
      'Er beruhigt und gibt deiner Marke eine sanftmütige, friedliche und ruhige Präsenz.',

    'floriental':
      'Dein Markenduft ist sinnlich und verlockend: üppig, berauschend und opulent. ' +
      'Er zieht deine Zielgruppe an und macht deine Marke sinnlich, magnetisch und hingebungsvoll.',

    'milch-moschus':
      'Dein Markenduft ist der kürzeste Abstand zwischen deiner Marke und der Welt: milchig, cremig und hautnah. ' +
      'Er schafft Nähe und gibt deiner Marke etwas Geborgenes, Behütetes und Beschützendes.',

    'gourmand':
      'Dein Markenduft ist Verwöhnung: süß, vanillig und sirupartig. ' +
      'Er verführt deine Zielgruppe und positioniert deine Marke genussvoll, verspielt und verwöhnend.',

    'orientalisch':
      'Dein Markenduft ist ein Statement: harzig, balsamisch und orientalisch. ' +
      'Er bleibt in Erinnerung und gibt deiner Marke etwas Geheimnisvolles, Tiefgründiges und Versunkenes.',

    'wuerzig':
      'Dein Markenduft hat Kraft: pfeffrig, wärmend und feurig. ' +
      'Er fordert Aufmerksamkeit und stellt deine Marke selbstsicher, mutig und entschlossen auf.',

    'holzig':
      'Dein Markenduft hat Substanz: trocken, warm und rauchig. ' +
      'Er gibt Halt und verankert deine Marke stabil, standhaft und zentriert.',

    'chypre':
      'Dein Markenduft hat die Kraft der Stille: herb, moosig, chypre. ' +
      'Er wirkt ohne Lautstärke und macht deine Marke souverän, selbstbestimmt und charismatisch.',
  },

  bridge: {

    'fruchtig→chypre':
      'Das Erdig-Ledrige gibt deinem fruchtigen Genuss eine souveräne, charismatische Tiefe.',
    'fruchtig→zitrisch':
      'Das Zitrische bricht die Fruchtigkeit mit spritziger, befreiender Helligkeit.',

    'zitrisch→fruchtig':
      'Die Fruchtigkeit gibt deiner Spritzigkeit eine lebensfreudige, unbeschwerte Wärme.',
    'zitrisch→aromatisch':
      'Das Aromatische öffnet die Spritzigkeit um eine fokussierte, tatkräftige Botanik.',

    'aromatisch→zitrisch':
      'Das Zitrische gibt deiner Botanik eine optimistische, aufgeschlossene Leichtigkeit.',
    'aromatisch→aquatisch':
      'Das Aquatische öffnet deine Kraft um eine maritime, befreiende Weite.',

    'aquatisch→aromatisch':
      'Das Aromatische gibt deiner Klarheit einen fokussierten, vitalen Kern.',
    'aquatisch→frisch':
      'Das Frische gibt deiner Klarheit eine kristalline, puristische Leichtigkeit.',

    'frisch→aquatisch':
      'Das Aquatische gibt deiner Reinheit eine befreite, ausgeglichene Weite.',
    'frisch→floral-klar':
      'Das Floral-klare gibt deiner Kühlheit eine luftige, schwebende Transparenz.',

    'floral-klar→frisch':
      'Das Frische gibt deiner Luftigkeit eine erfrischt, gelöste Klarheit.',
    'floral-klar→gruen':
      'Das Grüne gibt deiner Transparenz eine zuversichtliche, geerdetete Frische.',

    'gruen→floral-klar':
      'Das Floral-klare gibt deiner Grünheit eine heitere, ungezwungene Leichtigkeit.',
    'gruen→floral':
      'Das Florale gibt deiner Knackigkeit eine anmutige, zärtliche Eleganz.',

    'floral→gruen':
      'Das Grüne gibt deiner Eleganz eine zuversichtliche, erholte Erdung.',
    'floral→pudrig':
      'Das Pudrige gibt deiner Anmut eine sanftmütige, friedliche Wärme.',

    'pudrig→floral':
      'Das Florale gibt deiner Sanftheit eine anmutige, herzliche Eleganz.',
    'pudrig→floriental':
      'Das Floriental vertieft deine Ruhe um eine sinnliche, magnetische Dimension.',

    'floriental→pudrig':
      'Das Pudrige trägt deine Sinnlichkeit in eine sanftmütige, friedliche Harmonie.',
    'floriental→milch-moschus':
      'Das Milchige gibt deiner Opulenz eine cremige, vertraute Intimität.',

    'milch-moschus→floriental':
      'Das Floriental umhüllt deine Geborgenheit mit einer üppigen, magnetischen Wärme.',
    'milch-moschus→gourmand':
      'Das Gourmand gibt deiner Cremigkeit eine genussvolle, verspielte Verwöhnung.',

    'gourmand→milch-moschus':
      'Das Milchige gibt deinem Genuss eine geborgene, behütete Weichheit.',
    'gourmand→orientalisch':
      'Das Amber gibt deiner Süße eine geheimnisvolle, tiefgründige Tiefe.',

    'orientalisch→gourmand':
      'Das Gourmand gibt deiner Tiefe eine genussvolle, verspielte Wärme.',
    'orientalisch→wuerzig':
      'Das Würzige gibt deinem Geheimnis eine selbstsichere, mutige Kraft.',

    'wuerzig→orientalisch':
      'Das Amber verleiht deiner Selbstsicherheit eine geheimnisvolle, versunkene Resonanz.',
    'wuerzig→holzig':
      'Das Holzige gibt deinem Mut eine stabile, standhaft zentrierte Basis.',

    'holzig→wuerzig':
      'Das Würzige gibt deiner Stabilität eine selbstsichere, entschlossene Kante.',
    'holzig→chypre':
      'Das Erdig-Ledrige gibt deiner Substanz eine souveräne, charismatische Präsenz.',

    'chypre→holzig':
      'Das Holzige vertieft deine Souveränität um eine stabile, zentrierte Solidität.',
    'chypre→fruchtig':
      'Das Fruchtige rundet deine Charisma um eine lebensfreudige, ausgelassene Wärme.',
  },

  presence: {
    'intim':
      'Dein Markenduft bleibt im engsten Kreis: spürbar nur im direkten Kontakt, ' +
      'für die, die deiner Marke wirklich nahekommen.',

    'moderat':
      'Dein Markenduft ist eine stille Signatur: spürbar für alle, die deiner Marke nah genug kommen.',

    'intensiv':
      'Dein Markenduft ist eine Anwesenheit: Wer deiner Marke begegnet, nimmt ihn wahr ' +
      'und vergisst ihn so schnell nicht.',

    'statement':
      'Dein Markenduft definiert den Raum, bevor das erste Wort fällt. ' +
      'Die olfaktorische Ansage deiner Marke.',
  },

};

window.FRAGRANCE_QUIZ_PROFILES_EN = {

  intro: {

    'fruchtig':
      'Your brand scent is pure pleasure: juicy, ripe and radiant. It sparks instant joy in your ' +
      'audience and gives your brand a lively, carefree lightness.',

    'zitrisch':
      'Your brand scent lands instantly: zesty, sparkling and liberatingly bright. It opens up your ' +
      "audience's day and positions your brand as optimistic, awake and open.",

    'aromatisch':
      'Your brand scent smells of herbs crushed between the fingers: herbal, botanical, direct. ' +
      'It wakes your audience and anchors your brand as focused, vital and driven.',

    'aquatisch':
      'Your brand scent carries the openness of the sea: watery, marine, mineral-clear. ' +
      'It clears the head and gives your brand a liberated, balanced clarity.',

    'frisch':
      'Your brand scent is purity: cool, crystalline and pared back. It stays with you, no detours, ' +
      'and positions your brand as refreshed, light and at ease.',

    'floral-klar':
      'Your brand scent is air itself: airy, translucent and weightless. It lifts every weight ' +
      'and gives your brand a serene, easygoing and relaxed presence.',

    'gruen':
      'Your brand scent is the first breath in the garden: green, leafy and crisp. ' +
      'It feels restorative and positions your brand as confident, restored and grounded.',

    'floral':
      'Your brand scent has the elegance of blossoms: flowery, elegant and captivating. ' +
      'It touches your audience and gives your brand a graceful, tender and warm note.',

    'pudrig':
      'Your brand scent settles like a soft coat around the shoulders: powdery, velvety and soft. ' +
      'It calms and gives your brand a gentle, peaceful and quiet presence.',

    'floriental':
      'Your brand scent is sensual and inviting: lush, intoxicating and opulent. ' +
      'It draws your audience in and makes your brand sensual, magnetic and devoted.',

    'milch-moschus':
      'Your brand scent is the shortest distance between your brand and the world: milky, creamy and close to the skin. ' +
      'It builds closeness and gives your brand something secure, sheltered and protective.',

    'gourmand':
      'Your brand scent is indulgence: sweet, vanilla and syrupy. ' +
      'It tempts your audience and positions your brand as indulgent, playful and pampering.',

    'orientalisch':
      'Your brand scent is a statement: resinous, balsamic and oriental. ' +
      'It stays in memory and gives your brand something mysterious, profound and absorbed.',

    'wuerzig':
      'Your brand scent has force: peppery, warming and fiery. ' +
      'It commands attention and positions your brand as self-assured, bold and determined.',

    'holzig':
      'Your brand scent has substance: dry, warm and smoky. ' +
      'It gives support and anchors your brand as stable, steadfast and centered.',

    'chypre':
      'Your brand scent holds the power of stillness: bracing, mossy, chypre. ' +
      'It works without volume and makes your brand commanding, self-determined and charismatic.',
  },

  bridge: {

    'fruchtig→chypre':
      'The earthy-leather note lends your fruity pleasure a commanding, charismatic depth.',
    'fruchtig→zitrisch':
      'The citrus breaks the fruit open with a zesty, liberating brightness.',

    'zitrisch→fruchtig':
      'The fruit gives your zest a joyful, carefree warmth.',
    'zitrisch→aromatisch':
      'The aromatic opens your zest into a focused, driven botany.',

    'aromatisch→zitrisch':
      'The citrus gives your botany an optimistic, open lightness.',
    'aromatisch→aquatisch':
      'The aquatic opens your force into a marine, liberating expanse.',

    'aquatisch→aromatisch':
      'The aromatic gives your clarity a focused, vital core.',
    'aquatisch→frisch':
      'The fresh gives your clarity a crystalline, pared-back lightness.',

    'frisch→aquatisch':
      'The aquatic gives your purity a liberated, balanced expanse.',
    'frisch→floral-klar':
      'The sheer floral gives your coolness an airy, weightless translucence.',

    'floral-klar→frisch':
      'The fresh gives your airiness a refreshed, easy clarity.',
    'floral-klar→gruen':
      'The green gives your translucence a confident, grounded freshness.',

    'gruen→floral-klar':
      'The sheer floral gives your green a serene, easygoing lightness.',
    'gruen→floral':
      'The floral gives your crispness a graceful, tender elegance.',

    'floral→gruen':
      'The green gives your elegance a confident, restored grounding.',
    'floral→pudrig':
      'The powdery gives your grace a gentle, peaceful warmth.',

    'pudrig→floral':
      'The floral gives your softness a graceful, warm elegance.',
    'pudrig→floriental':
      'The floriental deepens your calm into a sensual, magnetic dimension.',

    'floriental→pudrig':
      'The powdery carries your sensuality into a gentle, peaceful harmony.',
    'floriental→milch-moschus':
      'The milky gives your opulence a creamy, familiar intimacy.',

    'milch-moschus→floriental':
      'The floriental wraps your sense of security in a lush, magnetic warmth.',
    'milch-moschus→gourmand':
      'The gourmand gives your creaminess an indulgent, playful sweetness.',

    'gourmand→milch-moschus':
      'The milky gives your pleasure a secure, sheltered softness.',
    'gourmand→orientalisch':
      'The amber gives your sweetness a mysterious, profound depth.',

    'orientalisch→gourmand':
      'The gourmand gives your depth an indulgent, playful warmth.',
    'orientalisch→wuerzig':
      'The spice gives your mystery a self-assured, bold force.',

    'wuerzig→orientalisch':
      'The amber lends your confidence a mysterious, absorbed resonance.',
    'wuerzig→holzig':
      'The woody gives your courage a stable, steadfast, centered base.',

    'holzig→wuerzig':
      'The spice gives your stability a self-assured, determined edge.',
    'holzig→chypre':
      'The earthy-leather gives your substance a commanding, charismatic presence.',

    'chypre→holzig':
      'The woody deepens your composure into a stable, centered solidity.',
    'chypre→fruchtig':
      'The fruit rounds your charisma with a joyful, exuberant warmth.',
  },

  presence: {
    'intim':
      'Your brand scent stays in the closest circle: noticeable only in direct contact, ' +
      'for those who come truly close to your brand.',

    'moderat':
      'Your brand scent is a quiet signature: noticeable to everyone who comes close enough to your brand.',

    'intensiv':
      'Your brand scent is a presence: anyone who meets your brand takes it in ' +
      'and will not forget it any time soon.',

    'statement':
      'Your brand scent defines the room before the first word is spoken. ' +
      "Your brand's olfactory statement.",
  },

};

window.FRAGRANCE_QUIZ_PROFILES =
  (typeof window !== 'undefined' && window.FQ_LANG === 'en')
    ? window.FRAGRANCE_QUIZ_PROFILES_EN
    : window.FRAGRANCE_QUIZ_PROFILES_DE;
